import { agentWidgetsApiBaseUrl } from '../../api/server';

let integration = null;
let loading = null;
const scriptUrl = () => new URL(process.env.REACT_APP_AGENT_WIDGET_SCRIPT_URL || 'https://cdn.jsdelivr.net/npm/anthropod-voice-widget@latest/dist/widget.umd.js', window.location.origin).href;
const escapeAttribute = value => String(value).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;').replace(/>/g, '&gt;');

export function createAgentWidgetEmbed({ widgetId, publicApiKey }) {
  return `<script src="${escapeAttribute(scriptUrl())}"></script>
<anthropod-agent-widget widget-id="${escapeAttribute(widgetId)}" public-api-key="${escapeAttribute(publicApiKey)}" api-base-url="${escapeAttribute(agentWidgetsApiBaseUrl)}"></anthropod-agent-widget>`;
}

export function loadSharedWidgetUI() {
  if (integration) return Promise.resolve(integration);
  if (window.VoiceBotWidget?.mountTestChat) { integration = window.VoiceBotWidget; return Promise.resolve(integration); }
  if (loading) return loading;
  loading = new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = scriptUrl(); script.async = true;
    script.onload = () => {
      if (!window.VoiceBotWidget?.mountTestChat || !window.VoiceBotWidget?.createDashboardSessionAdapter) {
        script.remove(); loading = null; reject(new Error('The chat widget is unavailable. Please reload and try again.')); return;
      }
      integration = window.VoiceBotWidget; resolve(integration);
    };
    script.onerror = () => { script.remove(); loading = null; reject(new Error('Unable to load the chat widget. Please reload and try again.')); };
    document.head.appendChild(script);
  });
  return loading;
}
